module.exports = __webpack_public_path__ + "static/media/twitter-share.551701e1.svg";